import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  ElementRef,
  HostListener,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-custom-dropdown',
  standalone: false,
  templateUrl: './custom-dropdown.component.html',
  styleUrl: './custom-dropdown.component.scss',
  animations: [
    trigger('dropdownAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('100ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' })),
      ]),
    ]),
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomDropdownComponent),
      multi: true
    }
  ]
})
export class CustomDropdownComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() placeholder: string = 'Selecciona';
  @Input() displayProperty: string = 'label';
  @Input() showErrors: boolean = false;
  @Input() control: any = null;
  @Input() disabled: boolean = false;
  @Input() trackByFn?: (index: number, item: any) => any;


  private _options: any[] = [];
  private _initialValue: any = null;

  @Input()
  set options(value: any[]) {
    this._options = value;
    if (this._initialValue !== null) {
      this.selectedOption = this._options.find(opt => opt.value === this._initialValue) || null;
      this._initialValue = null;
    }
  }

  get options(): any[] {
    return this._options;
  }

  isOpen = false;
  selectedOption: any;

  private onChange = (_: any) => {};
  private onTouched = () => {};

  constructor(private eRef: ElementRef) {}

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: any, event: Event) {
    event.stopPropagation();
    this.selectedOption = option;
    this.onChange(option?.value);
    this.onTouched();
    this.isOpen = false;
  }

  writeValue(value: any): void {
    if (!this.options || this.options.length === 0) {
      this._initialValue = value;
      return;
    }
    this.selectedOption = this.options.find(opt => opt.value === value) || null;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  getErrorMessage() {
    if (this.control?.hasError('required')) {
      return 'Este campo es obligatorio';
    }
    return 'Campo inválido';
  }

  defaultTrackBy = (_: number, option: any) => option.value;

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: HTMLElement) {
    if (!this.eRef.nativeElement.contains(target)) {
      this.isOpen = false;
    }
  }

  handleKeyboard(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.isOpen = false;
    }
  }
}
